import { useMutation, UseMutationOptions, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { invalidateOrganizationGroups } from './useGetOrganizationGroups';

type Params = { name: string };
type Result = { id: string; name: string };

export const usePostOrganizationGroup = (
  options?: UseMutationOptions<Result, AxiosError, Params>,
): UseMutationResult<Result, AxiosError, Params> => {
  const queryClient = useQueryClient();
  return useMutation<Result, AxiosError, Params>({
    mutationFn: async ({ name }) => {
      const trimmed = name.trim();
      if (!trimmed) throw new Error('Nazwa grupy nie może być pusta');
      const res = await axiosInstance.post('/v3-createOrganizationGroup', { name: trimmed });
      return res.data.data as Result;
    },
    ...options,
    onSuccess: (...args) => {
      invalidateOrganizationGroups(queryClient);
      options?.onSuccess?.(...args);
    },
  });
};
